export class SuggestorType {
  id: number;
  name: string;

  constructor(data?: string, id?: number) {
    this.id = id ?? 0;
    this.name = data ?? '';
  }
}
